import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedService } from '../../services/shared.service';
import { ApplicationRef } from '@angular/core';

@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class SettingsModalComponent implements OnInit {
  isChatbotVisible: boolean = true;
  useAzureWebsocket: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    public sharedService: SharedService,
    private appRef: ApplicationRef,
  ) {}

  ngOnInit(): void {
    const hideChatbot = localStorage.getItem('hide_chatbot');
    this.isChatbotVisible = hideChatbot !== 'true';

    const lsWsVal = localStorage.getItem('use_azure_websocket');
    this.useAzureWebsocket = lsWsVal === 'true';
  }

  toggleChatbot(): void {
    if (this.isChatbotVisible) {
      localStorage.removeItem('hide_chatbot');
    } else {
      localStorage.setItem('hide_chatbot', 'true');
    }
    this.appRef.tick();
  }

  toggleAzureWebsocket(): void {
    localStorage.setItem('use_azure_websocket', String(this.useAzureWebsocket));
    window.location.reload();
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
